import { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ActionButton } from "../components/Button";
import { IconArrowRight } from "../components/Icons";
import PersonalityTab from "../../homeowner-profile/tabs/PersonalityTab";
import compatibilityCardImage from "../../../assets/home-page/matching/section4.png";
import compatibilityCardMobileImage from "../../../assets/home-page/matching/section4-mobile.png";

export const CompatibilitySection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <section className="sg-section sg-compatibility">
      <div className="sg-container">
        <div className="sg-section__header sg-section__header--compact">
          <h2 className="sg-section__title sg-section__title--magenta">
            Your Compatibility Card
          </h2>
          <p className="sg-section__subtitle sg-compatibility__subtitle">
            See exactly why you and your interior designer are a great match.
          </p>
        </div>

        <div className="sg-compatibility__image-wrap">
          <picture>
            <source
              srcSet={compatibilityCardMobileImage}
              media="(max-width: 640px)"
            />
            <img
              className="sg-compatibility__image"
              src={compatibilityCardImage}
              alt="Compatibility card preview"
            />
          </picture>
        </div>

        <div className="sg-compatibility__cta">
          <ActionButton variant="outline" size="md" onClick={() => setIsOpen(true)}>
            See Full Compatibility Details <IconArrowRight size={16} />
          </ActionButton>
        </div>
      </div>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        fullScreen={isMobile}
        fullWidth
        maxWidth="lg"
        scroll="paper"
        className="sg-compatibility-modal"
        PaperProps={{ className: "sg-compatibility-modal__paper" }}
      >
        <div className="sg-compatibility-modal__header">
          <Typography component="h3" className="sg-compatibility-modal__title">
            Compatibility Details
          </Typography>
          <IconButton
            aria-label="Close compatibility details"
            onClick={() => setIsOpen(false)}
            className="sg-compatibility-modal__close"
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent
          className="sg-compatibility-modal__content"
          sx={{ px: 0, pt: 0, pb: "100px" }}
        >
          <div className="sg-compatibility-modal__body">
            <PersonalityTab
              personalityType="Extrovert Blue Gold"
              profilePersonalityType="Extrovert Blue Gold"
              designerPersonalityType="Extrovert Blue Orange"
              viewerRole="homeowner"
              displayMode="compatibility"
              matchScore={92}
              showHeaderCompatibilityRating={false}
              viewerLabelOverride="Homeowner"
              counterpartLabelOverride="Designer"
              traitPrimaryLabelOverride="Homeowner"
              traitSecondaryLabelOverride="Designer"
            />
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};
